export const imgBaseUrl = 'https://oss.syounggroup.com/';
